module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-Black.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-Black.ttf
// module id = 1885
// module chunks = 0